import { Box, Divider, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useRecoilState } from 'recoil';
import ResetButton from '~/components/Buttons/ResetButton';
import { Slider } from '~/components/Slider';
import {
    defaultMainViewWidth,
    mainViewWidthState,
} from '~/state/atoms/toolsAtoms';

const ResizeLayoutModifier = () => {
    const [mainViewWidth, setMainViewWidth] =
        useRecoilState(mainViewWidthState);

    const handleReset = () => {
        setMainViewWidth(defaultMainViewWidth);
    };

    return (
        <Stack display="flex" flexDirection="column" gap={1}>
            <Slider
                label={
                    <Box display={'flex'} alignItems={'center'}>
                        <Typography fontSize={15}>
                            <FormattedMessage id="mainViewWidth" />
                        </Typography>
                        <Divider
                            flexItem
                            orientation="vertical"
                            sx={{ mx: 1, my: 0.5 }}
                        />
                        <ResetButton onClick={handleReset} />
                    </Box>
                }
                min={50}
                max={70}
                value={mainViewWidth}
                step={0.1}
                onChange={setMainViewWidth}
            />
        </Stack>
    );
};

export default ResizeLayoutModifier;
